module.exports = __webpack_public_path__ + "img/Edelstahlhandlauf_rathaus.0d5b3f15.jpg";